import React, { useState } from 'react';
import { ArrowRightIcon, LayersIcon, TargetIcon } from 'lucide-react';
import { CardLabel, Fade, Hi, Slide, SlideHeader } from '../deck/Slide';
import { AppendixSlide } from './appendix/AppendixSlide';
import { OptionADetail } from './details/OptionADetail';
import { OptionBDetail } from './details/OptionBDetail';
const options = [{
  id: 'a',
  number: 'A',
  icon: LayersIcon,
  title: 'Strategic EU5 Portfolio Pilot',
  subtitle: '3 corporate brands, 5 EU5 markets',
  price: '€250,700',
  accent: 'var(--brand-green-light)',
  points: ['5 Master Campaigns across the portfolio', 'Full Control Tower platform', 'Tests the centralized hub at real scale'],
  detailLabel: 'Option A, full breakdown',
  detailTitle: 'The Strategic EU5 Portfolio Pilot'
}, {
  id: 'b',
  number: 'B',
  icon: TargetIcon,
  title: '"Immediate Impact" Anzupgo Pilot',
  subtitle: '1 brand, 5 EU5 markets',
  price: '€112,900',
  accent: 'var(--brand-green)',
  points: ['2 Master Campaigns, EU5 adaptation included', 'Localized Control Tower setup', 'Lightest entry against year-end budgets'],
  detailLabel: 'Option B, full breakdown',
  detailTitle: 'Anzupgo across EU5, costed line by line'
}];
export function PilotOptionsSlide() {
  const [openId, setOpenId] = useState<string | null>(null);
  const active = options.find(option => option.id === openId) ?? null;
  if (active) {
    return <AppendixSlide eyebrow={active.detailLabel} title={active.detailTitle} backLabel="Back to options" onBack={() => setOpenId(null)} data-id="element-167" data-mp="d5br37dsqg24">
        <div className="min-h-0 flex-1 overflow-y-auto pr-1" data-id="element-168" data-mp="3ujh4g5zl7lk2">
          {active.id === 'a' ? <OptionADetail data-id="element-169" data-mp="3cxlu4nierb7" /> : <OptionBDetail data-id="element-170" data-mp="r4l98clkbk8q" />}
        </div>
      </AppendixSlide>;
  }
  return <Slide data-id="element-171" data-mp="r2i8oymsa8pr">
      <SlideHeader eyebrow="Flexible pilot options for Q4" data-id="element-172" data-mp="vvbbvi2lt8zq">
        Two entry points, sized for what&rsquo;s left in 2026 and{' '}
        <Hi data-id="element-173" data-mp="15rjyc0wy62ka">proven in time for 2027 planning.</Hi>
      </SlideHeader>

      <div className="flex min-h-0 flex-1 items-stretch gap-[clamp(1.25rem,2.5vw,2.5rem)]" data-id="element-174" data-mp="10s79xbqfgnfl">
        {options.map((option, index) => <Fade key={option.id} delay={0.2 + index * 0.15} className="flex flex-1" data-id="element-175" data-mp="vs2t1kllxqou" data-mpi={index}>
            <button type="button" onClick={() => setOpenId(option.id)} className="group relative flex flex-1 flex-col overflow-hidden rounded-2xl border border-black/5 bg-[var(--surface)] p-[clamp(1.25rem,2.2vw,2.25rem)] text-left shadow-sm transition-colors hover:border-[var(--brand-green-light)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-green)]" data-id="element-176" data-mp="rs26fcocu96p">
              <div className="absolute left-0 top-0 h-full w-1.5" style={{
            backgroundColor: option.accent
          }} data-id="element-177" data-mp="854ggy0lz2w7" />
              <div className="mb-5 flex items-start gap-4" data-id="element-178" data-mp="3v7ppfupqj3xr">
                <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full" style={{
              backgroundColor: option.accent
            }} data-id="element-179" data-mp="3vac4sgivanqj">
                  <option.icon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-180" data-mp="2fre6j34onuos" />
                </div>
                <div data-id="element-181" data-mp="2jp29mtgj4trr">
                  <CardLabel data-id="element-182" data-mp="2opq09e0uj8lg">Option {option.number}</CardLabel>
                  <h3 className="text-[clamp(1.15rem,1.8vw,1.75rem)] font-bold leading-tight text-[var(--fg)]" data-id="element-183" data-mp="2onvmcjnzsgqv">
                    {option.title}
                  </h3>
                  <p className="mt-1 text-[clamp(0.8rem,1vw,1rem)] font-medium text-[var(--muted)]" data-id="element-184" data-mp="1w23ubz45brvf">
                    {option.subtitle}
                  </p>
                </div>
              </div>

              <ul className="space-y-3" data-id="element-185" data-mp="25rvr8zzpwx32">
                {option.points.map(point => <li key={point} className="flex items-start gap-3" data-id="element-186" data-mp="18aoldnhv6cb7">
                    <ArrowRightIcon className="mt-1 h-4 w-4 flex-shrink-0" style={{
                color: option.accent
              }} aria-hidden="true" data-id="element-187" data-mp="1dab0y3l604n6" />
                    <span className="text-[clamp(0.85rem,1vw,1rem)] font-medium leading-relaxed text-[var(--muted)]" data-id="element-188" data-mp="3az6hkt1qh7wy">
                      {point}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-auto flex items-end justify-between border-t border-black/10 pt-5" data-id="element-189" data-mp="3jxs5z4tvzh5n">
                <div data-id="element-190" data-mp="2gqtwfofbiy7">
                  <CardLabel tone="muted" data-id="element-191" data-mp="2kekb5yknp8p">Investment</CardLabel>
                  <span className="mt-1 flex items-center gap-2 text-[clamp(0.7rem,0.9vw,0.9rem)] font-bold uppercase tracking-wider text-[var(--brand-green)]" data-id="element-192" data-mp="3tod0oh6fw1ja">
                    See the breakdown
                    <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-193" data-mp="7i6cm134pddf" />
                  </span>
                </div>
                <p className="text-[clamp(1.5rem,3vw,2.75rem)] font-bold leading-none text-[var(--fg)]" data-id="element-194" data-mp="29be03xswb1ae">
                  {option.price}
                </p>
              </div>
            </button>
          </Fade>)}
      </div>

      <Fade delay={0.55} className="mt-[clamp(0.75rem,1.5vw,1.5rem)] flex-shrink-0" data-id="element-195" data-mp="1pg2zy5lqcuns">
        <p className="border-l-2 border-[var(--brand-green)] pl-4 text-[clamp(0.9rem,1.2vw,1.2rem)] font-medium text-[var(--muted)]" data-id="element-196" data-mp="1uduruzmdkgrz">
          Either way, this lifts traffic and assets you have already paid for,
          and the rest of the portfolio joins in the 2027 cycle.
        </p>
      </Fade>
    </Slide>;
}